import { useQuery } from '@apollo/client';
import query from '../../queries/referrerDetail';

export default function useReferrerDetail(options = {}) {
  const { data, ...rest } = useQuery(query, {
    ...options,
  });

  const referrerDetail = data?.referrerDetail;

  return {
    referrerDetail,
    ...rest
  };
}
